import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { Schedule } from "./pages/Schedule";
import { Memberships } from "./pages/Memberships";
import { Coaches } from "./pages/Coaches";
import { Results } from "./pages/Results";
import { Account } from "./pages/Account";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/memberships" element={<Memberships />} />
          <Route path="/coaches" element={<Coaches />} />
          <Route path="/results" element={<Results />} />
          <Route path="/account" element={<Account />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
